import { FC, memo } from 'react'
import { Stencil, stencil, UnsupportedBrowserNotice } from 'react-common'

import { TenantLogoPlugin } from '@/features/stencil/TenantLogoPlugin/TenantLogoPlugin'
import styles from './PublicStencilPreset.module.scss'
import { BreadcrumbsPluginContainer } from '../BreadcrumbsPluginContainer/BreadcrumbsPluginContainer'
import { PublicCatalogHamburgerContainer } from '../PublicCatalogHamburgerContainer/PublicCatalogHamburgerContainer'
import { SideBarPluginContainer } from '../SideBarPluginContainer/SideBarPluginContainer'

const { HeaderPlugin, PublicThemePlugin, SetCustomBrandingColorsPlugin } = stencil

type Props = {
  children: React.ReactNode
  hideMenu?: boolean
  logoUrl?: string
}

// INFO: this Stencil component re-renders at every route change, that's why we need to memoize it
export const PublicStencilPreset: FC<Props> = memo(({ children, hideMenu, logoUrl }) => {
  return (
    <Stencil>
      <div className={styles.alertsContainer}>
        <UnsupportedBrowserNotice
          desktopBrowsers={['chrome', 'safari', 'edge']}
          mobileBrowsers={['chrome', 'safari']}
        />
      </div>

      <PublicThemePlugin />
      <SetCustomBrandingColorsPlugin accessMode="public" />
      <HeaderPlugin />
      <BreadcrumbsPluginContainer />
      <SideBarPluginContainer />
      {!hideMenu && <PublicCatalogHamburgerContainer />}
      <TenantLogoPlugin mode="public" link={logoUrl} />

      {children}
    </Stencil>
  )
})
